var _path, _path2, _path3, _path4, _path5;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgExclamationViolet = function SvgExclamationViolet(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8731 5.55429L26.3417 3.80343C24.923 2.60252 23.3056 1.65844 21.5623 1.01371L20.7817 3.16C22.2744 3.71363 23.6589 4.52464 24.8731 5.55429Z",
    fill: "#EE82EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4971 13.7143L31.7463 13.2423C31.43 11.4164 30.7964 9.65994 29.8743 8.05257L27.896 9.14286C28.6856 10.5646 29.2271 12.1106 29.4971 13.7143Z",
    fill: "#EE82EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7817 28.84L21.5623 30.9863C23.3055 30.3419 24.9229 29.3982 26.3417 28.1977L24.8731 26.4469C23.6589 27.4765 22.2744 28.2864 20.7817 28.84Z",
    fill: "#EE82EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.896 22.8571L29.8743 24C30.7968 22.374 31.4302 20.6003 31.7463 18.7577L29.4971 18.3611C29.2269 19.941 28.6852 21.4621 27.896 22.8571Z",
    fill: "#EE82EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32V0C11.7565 0 7.68687 1.68571 4.68629 4.68629C1.68571 7.68687 0 11.7565 0 16C0 20.2435 1.68571 24.3131 4.68629 27.3137C7.68687 30.3143 11.7565 32 16 32Z",
    fill: "#EE82EE"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExclamationViolet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exclamation-violet.b593b678.svg";
export { ForwardRef as ReactComponent };